import { Outlet, useLocation } from "react-router-dom";
import { NewsletterProvider } from "../context/NewsletterProvider";
import { Emails } from "./Emails";
import { EmptyInbox } from "./EmptyInbox";
import { useContext } from "react";
import { NewsletterContext } from "../context/NewsletterContext";
import { EmailProvider } from "../context/EmailProvider";

export const NewsletterDashboard = () => {
  const location = useLocation();
  const { config } = useContext(NewsletterContext);

  const hasNewsletter =
    config.topics.length > 0 ||
    config.tone ||
    config.frequency ||
    config.preferredDay;

  // Wrap the entire content in a single set of providers
  return (
    <NewsletterProvider>
      <EmailProvider>
        {location.pathname.includes("/setup") ||
        location.pathname.includes("/edit") ? (
          <Outlet />
        ) : (
          <div className="w-full py-8 flex justify-center">
            {hasNewsletter ? <Emails /> : <EmptyInbox />}
          </div>
        )}
      </EmailProvider>
    </NewsletterProvider>
  );
};
